module.exports = __webpack_public_path__ + "static/media/C.8d8cc970.png";


//////////////////
// WEBPACK FOOTER
// ./src/mobioastro/assets/images/C.png
// module id = 1349
// module chunks = 0